const ENV_APP_BASE_URL = (process.env.REACT_APP_APP_BASE_URL || "").replace(/\/+$/, "");

export function getAppBaseUrl() {
  if (ENV_APP_BASE_URL) {
    return ENV_APP_BASE_URL;
  }

  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  return "http://localhost:3000";
}

export function buildAppUrl(path: string) {
  const baseUrl = getAppBaseUrl();
  return `${baseUrl}${path.startsWith("/") ? path : `/${path}`}`;
}
